import api from './api';

const cmsService = {
  getAllPages: (params) => api.get('/cms', { params }),
  getPageById: (id) => api.get(`/cms/admin/${id}`),
  createPage: (data) => api.post('/cms', data),
  updatePage: (id, data) => api.put(`/cms/${id}`, data),
  deletePage: (id) => api.delete(`/cms/${id}`),
  toggleStatus: (id) => api.patch(`/cms/${id}/toggle-status`),
};

export default cmsService;
